/**
 * @param error - Axios error object from API call
 * @returns User-friendly error message string
 */
export const extractErrorMessage = (error: any): string => {
  const response = error?.response?.data;

  if (response?.errorMsg) {
    if (Array.isArray(response.errorMsg)) {
      return response.errorMsg[0] || "Validation error occurred";
    }
    if (typeof response.errorMsg === "string") {
      return response.errorMsg;
    }
  }
  if (response?.message) {
    return response.message;
  }

  return "An unexpected error occurred. Please try again.";
};
